<template>
    <div class="progress-bar-container" :style="getStyle">
        <span class="progress-indicator">{{ progression }}%</span>
    </div>
</template>
<script lang="ts">
export default {
    name: "ProgressBar",
    props: {
        progression: {
            type: Number,
            default: 0
        }
    },
    computed: {
        getStyle() {
            return {
                "--progression": `${this.progression}%`
            };
        }
    }
};
</script>
<style scoped>
.progress-bar-container {
    background-color: var(--secondary);
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-radius: 7px;
}

.progress-indicator {
    color: var(--secondary);
    display: flex;
    flex-direction: row;
    height: 100%;
    width: var(--progression);
    justify-content: center;
    align-items: center;
    background: var(--primary);
    border-radius: 7px;
    transition: width 0.1s ease-in;
}
</style>
